import {
  registerServiceWorker,
  getMobileUUID,
  getSubscription,
  createSubscription,
  isIOS,
  isPWA,
} from './util.js';
import { APIClient } from './api_client.js';
import { DOMManager } from './dom_manager.js';

async function getVapidPublicKey(apiClient) {
  try {
    const res = await apiClient.getVapidPublicKey();
    if (res.ok) {
      return await res.text();
    } else {
      console.error('Failed to get VAPID public key:', res.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error fetching VAPID public key:', error);
    return null;
  }
}

async function registerOrUpdateMobile(apiClient, mobileUuid, subscription) {
  try {
    const res = await apiClient.updateMobile(subscription);
    if (res.ok) {
      await apiClient.getMobile();
      return;
    }

    if (res.status === 401) {
      await apiClient.registerMobile(mobileUuid, subscription);
    }
  } catch (error) {
    console.error('Failed to register/update mobile subscription:', error);
  }
}

async function main() {
  // Register Service Worker
  const serviceWorker = await registerServiceWorker();

  // Initialize components
  const mobileUuid = getMobileUUID();
  const eventBus = new EventTarget();
  const apiClient = new APIClient(mobileUuid, eventBus);
  const domManager = new DOMManager(apiClient, eventBus, serviceWorker);

  try {
    await apiClient.autoLogin();

    domManager.initPage();

    // iOS PWA Guard
    if (isIOS() && !isPWA()) {
      domManager.showPWAGuide();
      return;
    }

    // Get subscription
    let subscription = await getSubscription(serviceWorker);
    if (!subscription) {
      if (Notification.permission === 'granted') {
        const vapidPublicKey = await getVapidPublicKey(apiClient);
        if (vapidPublicKey) {
          subscription = await createSubscription(
            serviceWorker,
            vapidPublicKey
          );
        }
      } else {
        subscription = {
          endpoint: 'none',
          keys: {
            p256dh: 'none',
            auth: 'none',
          },
        };
      }
    }

    await registerOrUpdateMobile(apiClient, mobileUuid, subscription);

    // A token subscription requires the device created by the bootstrap request.
    domManager.handleQrCodeSubscription();
  } catch (error) {
    domManager.showError(error);
  }
}

main();
